export default __webpack_public_path__ + "static/media/main-video.bd9f6642.mp4";